/**
 * Returns the PK_Users that have no resolved UUID yet and therefore need a request.
 *
 * @param {Array<{PK_User: string|number}>} usersList - Current account users.
 * @param {Object} cachedPairs - Map of PK_User → UUID already known.
 * @returns {Array<string>} PK_Users missing a UUID.
 */
export const getMissingUserPks = (usersList, cachedPairs) => {
    return usersList.map((user) => String(user.PK_User)).filter((pk) => !cachedPairs[pk]);
};
